<template>
  <div
    :id="position + '-wrapper'"
    class="fab-wrapper"
    v-on-clickaway="away"
    :style="[ fabPos, {zIndex: zIndex}, {position: positionType} ]"
  >
    <div :id="position + '-action'" class="actions-container" :style="listPos">
      <transition
        name="fab-actions-appear"
        :enter-active-class="transitionEnter"
        :leave-active-class="transitionLeave"
      >
        <ul v-show="toggle" class="fab-list">
          <template v-for="action in actions">
            <transition
              enter-active-class="animated quick zoomIn"
              leave-active-class="animated quick zoomOut"
            >
              <el-tooltip :content="action.tooltip" :placement="tooltipPos" :disabled="!action.tooltip">
                <li
                  v-show="toggle"
                  ref="actions"
                  :style="{ 'background-color': action.color || bgColor }"
                  @click="toParent(action.name)" class="pointer"
                >
                  <i :class="[ actionIconSize ,'fab-icon', action.icon]" />
                </li>
              </el-tooltip>
            </transition>
          </template>
        </ul>
      </transition>
    </div>
    <template>
      <el-tooltip :content="mainTooltip" :placement="tooltipPos" :disabled="!mainTooltip">
        <div
          @click="handleToggle"
          class="fab pointer"
          :style="{ 'background-color': bgColor, 'padding': paddingAmount }"
        >
          <i :class="[ mainIconSize , { rotate: toggle } ,'fab-icon main', mainIcon]" />
        </div>
      </el-tooltip>
    </template>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'FabSpeedDial',
  mixins: [clickaway],
  data() {
    return {
      toggle: false,
      iconSizes: {
        small: 'icon-sm',
        medium: 'icon-md',
        large: 'icon-lg',
      },
      mainIconSizes: {
        small: 'icon-md',
        medium: 'icon-lg',
        large: 'icon-xl',
      },
      paddingAmt: {
        small: '28px',
        medium: '32px',
        large: '38px',
      },
      positions: {
        'bottom-right': { right: '2vw', bottom: '6vh' },
        'bottom-left': { left: '5vw', bottom: '4vh' },
        'top-right': { right: '5vw', top: '4vh' },
        'top-left': { left: '5vw', top: '4vh' },
        default: { right: '2vw', bottom: '6vh' },
      },
    };
  },

  props: {
    bgColor: {
      type: String,
      default: null,
    },
    position: {
      default: 'bottom-right',
    },
    positionType: {
      default: 'fixed',
    },
    zIndex: {
      default: '999',
    },
    mainIcon: {
      default: 'fa fa-plus',
    },
    iconSize: {
      default: 'medium',
    },
    mainTooltip: {
      default: null,
    },
    fixedTooltip: {
      default: false,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    actionIconSize() {
      return this.iconSizes[this.iconSize] || 'icon-md';
    },
    mainIconSize() {
      return this.mainIconSizes[this.iconSize] || 'icon-lg';
    },
    paddingAmount() {
      return this.paddingAmt[this.iconSize] || '32px';
    },
    listPos() {
      if (this.position === 'top-right' || this.position === 'top-left') {
        return {
          top: '-20px',
          paddingTop: '20px',
        };
      }
      return {
        bottom: '-20px',
        paddingBottom: '20px',
      };
    },
    transitionEnter() {
      return this.animation.enter;
    },
    transitionLeave() {
      return this.animation.leave;
    },
    animation() {
      if (this.position.indexOf('top') !== -1) {
        return {
          enter: 'animated quick fadeInDown',
          leave: 'animated quick fadeOutUp',
        };
      }

      return {
        enter: 'animated fadeInUp',
        leave: 'animated fadeOutDown',
      };
    },
    tooltipPos() {
      return this.position.indexOf('right') !== -1 ? 'left' : 'right';
    },
    fabPos() {
      return this.positions[this.position] || this.positions.default;
    },
  },
  methods: {
    handleToggle() {
      this.$emit('click');

      if (this.actions.length) {
        this.toggle = !this.toggle;
      }
    },
    toParent(name) {
      this.$emit(name);
      this.toggle = false;
    },
    away() {
      this.toggle = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.animated.quick {
  animation-duration: 0.7s !important;
}

.fab-wrapper {
  z-index: 999;
}

.fab {
  background-color: $amaranth;
  border-color: $amaranth;
  border-radius: 50px;
  padding: 10px;
  width: 50px !important;
  height: 50px !important;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2), 0 4px 4px rgba(0, 0, 0, 0.15);
  z-index: 2;
  justify-content: center;
}

.fab .fab-icon {
  color: white;
  transition: 0.4s all;
  margin: 0px auto;
}

.fab .fab-icon.main {
  position: absolute;
}

.fab .fab-icon.main.rotate {
  transform: rotate(315deg);
  transition: opacity 0.3s ease-in, transform 0.4s;
}

.fab-list {
  position: relative;
  z-index: 1;
  margin: 2vh 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fab-list li {
  padding: 10px;
  margin-top: 2vh;
  display: flex;
  align-items: center;
  border-radius: 100px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2), 0 4px 4px rgba(0, 0, 0, 0.15);
}

.fab-list li .fab-icon {
  color: white;
  margin: 0px auto;
}

.pointer {
  cursor: pointer;
}

ul {
  list-style-type: none;
  padding: 0 !important;
}

.fab-wrapper .actions-container {
  overflow: hidden;
  z-index: 0;
  position: relative;
}

/* Rules for sizing the icon. */
.fab-icon.icon-sm {
  font-size: 16px;
}

.fab-icon.icon-md {
  font-size: 20px;
}

.fab-icon.icon-lg {
  font-size: 32px;
}

.fab-icon.icon-xl {
  font-size: 44px;
}

.fab-icon {
  width: 1em;
  text-align: center;
}

/* Rules for using icons as black on a light background. */
.fab-icon.md-dark {
  color: rgba(0, 0, 0, 0.54);
}

.fab-icon.md-dark.md-inactive {
  color: rgba(0, 0, 0, 0.26);
}

/* Rules for using icons as white on a dark background. */
.fab-icon.md-light {
  color: rgba(255, 255, 255, 1);
}

.fab-icon.md-light.md-inactive {
  color: rgba(255, 255, 255, 0.3);
}

@media screen and (max-width: 768px) {
  .fab-list {
    margin: 2vh 0;
  }
}
</style>



// WEBPACK FOOTER //
// FabSpeedDial.vue?a466d06a